import React, { useState } from "react";
import { toast } from "sonner";
import { PaperPlaneTilt, EnvelopeSimple } from "@phosphor-icons/react";
import { api, formatApiErrorDetail } from "../lib/api";
import { Reveal } from "../lib/motion";

export default function Newsletter() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) {
      toast.error("Please enter your email.");
      return;
    }
    setLoading(true);
    try {
      const { data } = await api.post("/subscribe", { email });
      if (data.status === "already_subscribed") {
        toast.success("You're already on the list — thank you.");
      } else {
        toast.success("Welcome aboard. Check your inbox.");
      }
      setEmail("");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="bg-cloud py-20 lg:py-24" data-testid="newsletter-section">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10">
        <Reveal className="grid items-center gap-10 rounded-[28px] border border-slate-100 bg-white p-10 lg:grid-cols-[1.2fr_1fr] lg:p-14">
          <div>
            <div className="flex items-center gap-3 text-xs font-bold uppercase tracking-[0.24em] text-teal">
              <span className="h-px w-8 bg-teal/50" /> Field Notes
            </div>
            <h2 className="mt-5 font-heading text-3xl font-medium leading-tight tracking-tight text-navy sm:text-4xl">
              Ideas for building companies that last.
            </h2>
            <p className="mt-4 max-w-md text-lg leading-relaxed text-slate-600">
              Occasional, practical notes on strategy, leadership, systems, and growth —
              written for founders. No noise.
            </p>
          </div>
          <form onSubmit={submit} data-testid="newsletter-form" className="w-full">
            <div className="flex flex-col gap-3 sm:flex-row">
              <div className="relative flex-1">
                <EnvelopeSimple
                  size={18}
                  className="pointer-events-none absolute left-4 top-1/2 -translate-y-1/2 text-slate-400"
                />
                <input
                  data-testid="newsletter-email"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  className="w-full rounded-full border border-slate-200 bg-white py-3.5 pl-11 pr-4 text-[15px] outline-none transition-colors duration-300 focus:border-navy"
                />
              </div>
              <button
                type="submit"
                data-testid="newsletter-submit"
                disabled={loading}
                className="inline-flex items-center justify-center gap-2 rounded-full bg-navy px-7 py-3.5 font-semibold text-white transition-transform duration-300 hover:-translate-y-0.5 hover:bg-navy-950 disabled:opacity-60"
              >
                {loading ? "Subscribing..." : "Subscribe"}
                {!loading && <PaperPlaneTilt size={16} weight="bold" />}
              </button>
            </div>
          </form>
        </Reveal>
      </div>
    </section>
  );
}
